import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Linkedin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cfa-portal/artifacts/waysuoc0_D35F1E2C-9684-4E11-BB45-5677C422C15C.png";

export const Footer = () => {
  return (
    <footer className="bg-[#0B1F3A] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Tagline */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Institut BIA" 
              className="h-16 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-[#F5F5F5]/80 text-sm leading-relaxed">
              Centre de Formation par Apprentissage dédié à l'excellence commerciale.
            </p>
            <div className="mt-6">
              <span className="text-[#C8A75A] font-serif-heading italic text-lg">
                Bâtir • Innover • Accomplir
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[#C8A75A] uppercase tracking-[0.2em] text-xs font-semibold mb-6">
              Navigation
            </h4>
            <nav className="space-y-3">
              <Link to="/" className="block text-[#F5F5F5]/80 hover:text-[#C8A75A] transition-colors text-sm" data-testid="footer-link-accueil">
                Accueil
              </Link>
              <Link to="/formation" className="block text-[#F5F5F5]/80 hover:text-[#C8A75A] transition-colors text-sm" data-testid="footer-link-formation">
                Notre Formation
              </Link>
              <Link to="/etudiants" className="block text-[#F5F5F5]/80 hover:text-[#C8A75A] transition-colors text-sm" data-testid="footer-link-etudiants">
                Espace Étudiants
              </Link>
              <Link to="/employeurs" className="block text-[#F5F5F5]/80 hover:text-[#C8A75A] transition-colors text-sm" data-testid="footer-link-employeurs">
                Espace Employeurs
              </Link>
              <Link to="/contact" className="block text-[#F5F5F5]/80 hover:text-[#C8A75A] transition-colors text-sm" data-testid="footer-link-contact">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[#C8A75A] uppercase tracking-[0.2em] text-xs font-semibold mb-6">
              Contact
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-[#C8A75A] flex-shrink-0 mt-0.5" />
                <span className="text-[#F5F5F5]/80 text-sm">
                  Institut BIA<br />
                  Saint-Denis (93)<br />
                  Métro Ligne 13
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={18} className="text-[#C8A75A] flex-shrink-0" />
                <a href="mailto:contact@institut-bia.fr" className="text-[#F5F5F5]/80 hover:text-[#C8A75A] transition-colors text-sm">
                  contact@institut-bia.fr
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-[#C8A75A] flex-shrink-0" />
                <span className="text-[#F5F5F5]/80 text-sm">
                  +33 1 87 66 30 91
                </span>
              </div>
            </div>
          </div>

          {/* Certifications */}
          <div>
            <h4 className="text-[#C8A75A] uppercase tracking-[0.2em] text-xs font-semibold mb-6">
              Certifications
            </h4>
            <div className="space-y-3 text-sm text-[#F5F5F5]/80">
              <p>CFA déclaré DREETS Île-de-France</p>
              <p>RNCP39063 Niveau 5</p>
              <p>Qualiopi en cours</p>
            </div>
            <div className="mt-6 flex gap-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#F5F5F5]/60 hover:text-[#C8A75A] transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#F5F5F5]/60 text-xs">
              © {new Date().getFullYear()} Institut BIA. Tous droits réservés.
            </p>
            <div className="flex gap-6 text-xs">
              <Link to="/mentions-legales" className="text-[#F5F5F5]/60 hover:text-[#C8A75A] transition-colors">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="text-[#F5F5F5]/60 hover:text-[#C8A75A] transition-colors">
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
